import React from 'react';
import cn from 'classnames';
import { formatUSD } from 'utils';
import Loader from 'components/Loader';

import styles from './MetricItem.module.css';

type MetricItemProps = {
  label?: string;
  amount?: number;
  isLoading?: boolean;
  isUsd?: boolean;
};

const MetricItem: React.FC<MetricItemProps> = ({
  label,
  amount,
  isLoading = false,
  isUsd = true,
}) => (
  <div className={cn(styles.wrapper)}>
    {label && <div className={cn(styles.label)}>{label}</div>}
    {isLoading && <Loader className={cn(styles.loader)} />}
    {!isLoading && amount !== undefined && (
      <div className={cn(styles.amount)}>{isUsd ? formatUSD(amount) : amount}</div>
    )}
  </div>
);

export default MetricItem;
